// *** STEPS TO IMPLEMENT ON SITE ***
// Add 'js-validateForm' class to each form
// Make sure the form submission button is a button with type 'submit'

// *** MULTISTEP FORM REQUIREMENTS ***
// Final submit button must be a button with type 'submit'
// Any buttons that change the form step must be labeled with the 'data-stepchange' attribute
// NOTE: the data attr had to be changed from data-step-change to data-stepchange. The hyphen was causing issues
// Each step of the form must be contained in a div with the 'data-step' attribute

//vars to control ajax eror messages and bugsnag

document.addEventListener("DOMContentLoaded", function () {
    runValidation();
});


function runValidation() {
    const allLTforms = document.querySelectorAll(".js-validateForm");

    if (!allLTforms.length) {
        return;
    }

    const validateFormInputs = document.querySelectorAll(".js-validateForm input.c-form__control");
    const form_submits = document.querySelectorAll(".js-validateForm button[type=submit]");
    const nextStepButtons = document.querySelectorAll("[data-stepchange]");
    const phoneMasks = document.getElementsByName("phone");
    const errorMax = 2;
    let errorNum = 0;

    async function ltsubmit(e) {
        var form = e.target.closest(".js-validateForm");

        if (form.dataset.onSubmit === "noSubmit") {
            return;
        }

        if (form.dataset.onsubmitfn) {
            e.preventDefault();
            handleOnSubmitFunction(form.dataset.onsubmitfn, form);
        } else if (e.target.action.indexOf("/FormParser.php") >= 0) {
            e.preventDefault();
            ajaxValidation(form);
        }
    }

    const trimInputWhitespace = (e) => {
        e.target.value = e.target.value.trim();
    };

    const check_f_name = (e) => {
        var form = e.target.closest(".js-validateForm");
        var f_name = form.querySelector("input[name=f_name]");
        if (f_name && f_name.value.length == 0) {
            f_name.required = "";
        }
    };

    const handleOnSubmitFunction = (functionName, form) => {
        if (
            typeof window[functionName] !== "undefined" &&
            typeof window[functionName] === "function"
        ) {
            window[functionName](form);
        } else {
            console.warn("Function for submit missing.");
        }
    }

    const isLocalStorageAvailable = (storage) => {
        try {
            const test = 'test';
            storage.setItem(test, test);
            storage.removeItem(test);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    const saveUserInfoToLocal = (fullName, email, diagnosis, phoneNumber, requestedService, fbTrackFormConversion) => {
        if (isLocalStorageAvailable(localStorage)) {
            localStorage.setItem("fullName", fullName);
            localStorage.setItem("email", email);
            localStorage.setItem("diagnosis", diagnosis);
            localStorage.setItem("phoneNumber", phoneNumber);
            localStorage.setItem("requested_service", requestedService);

            if (fbTrackFormConversion) {
                localStorage.setItem("fbTrackFormConversion", requestedService);
            }
        } else {
            console.warn("No local storage available");
        }
    };

    const formatPhoneNumber = (el) => {
        const target = el.target;
        let digits = target.value.replace(/\D/g, '');

		if (digits.length === 11 && digits.startsWith('1')) {
			digits = digits.slice(1);
		}

		digits = digits.slice(0, 10);

		const m = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
		const masked = !m?.[2]
			? m?.[1] ?? ''
			: `(${m[1]}) ${m[2]}${m[3] ? '-' + m[3] : ''}`;

		target.value = masked;
        target.dataset.raw = digits;
    }

    const validatePhone = (e) => {
        const target = e.target;
        target.setCustomValidity('');

        //check if phone number is in valid US format
        const isValidFormat = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(target.value);
        const startsWith1 = target.value.replace(/\D/g, '').startsWith('1');
        if (!isValidFormat || startsWith1) {
            target.setCustomValidity('Please enter a valid phone number.');
        }
    }

    const formatAndValidatePhone = (e) => {
        formatPhoneNumber(e);
        validatePhone(e);
    }

    const formStepChange = (e) => {
        const form = e.target.closest(".js-validateForm");
        if (!form) {
            return;
        }

        // EARLY RETURN SINCE THIS CONFLICTS WITH NEW FORM
        if (form.classList.contains('c-form--dfe')) {
            return;
        }
        // EARLY RETURN SINCE THIS CONFLICTS WITH NEW FORM

        e.preventDefault();
        const targetStepNum = e.target.closest("[data-stepchange]").dataset.stepchange;
        const currentStep = form.querySelector("fieldset.is-active");
        const currentStepNum = currentStep.dataset.step;

        if (!targetStepNum || !currentStep || currentStepNum === targetStepNum) {
            return;
        }

        const targetStep = form.querySelector(`fieldset[data-step="${targetStepNum}"]`);

        if (targetStepNum > currentStepNum) {
            const stepInputs = Array.from(currentStep.querySelectorAll(
                "input:not([type=hidden]):not([name=f_name]):not([disabled]), .c-form__control:not([name=f_name]):not([disabled])"
            ));

            if (stepInputs.length === 0) {
                navigateToStep(form, currentStep, targetStep, targetStepNum);
                return;
            }

            const isValid = stepInputs.every(input => {
                input.value = input.value.trim();
                return input.checkValidity() === true;
            });

            if (isValid) {
                if (typeof formStepSuccessEvent === "function" && form.querySelectorAll('.c-form__steps').length) {
                    formStepSuccessEvent(form);
                }
                if (typeof formStepSubmitEvent === "function") {
                    formStepSubmitEvent(form);
                }
                checkCountryOrigin(form); // Check if country of origin is US or not
                navigateToStep(form, currentStep, targetStep, targetStepNum);
            } else {
                // Temporary solution for IE11
                form.getElementsByClassName("c-form__submit")[0].click();
            }
        } else {
            navigateToStep(form, currentStep, targetStep, targetStepNum);
        }
    }

    allLTforms.forEach((form) => {
        form.addEventListener("submit", ltsubmit, false);
    });

    validateFormInputs.forEach((input) => {
        input.addEventListener("blur", trimInputWhitespace, false);
    });

    form_submits.forEach((form_submit) => {
        form_submit.addEventListener("click", check_f_name, false);
    });

    phoneMasks.forEach((phoneMask) => {
        phoneMask.addEventListener('input', formatAndValidatePhone);
    });

    nextStepButtons.forEach((nextStepButton) => {
        nextStepButton.addEventListener("click", formStepChange);
    });

    const sendFormData = (form) => {
        form.classList.add("c-form--submitting");
        form.getElementsByClassName("c-form__submit")[0].disabled = true;
        form.getElementsByClassName("c-form__submit-error")[0].style.display =
            "none";
        form.getElementsByClassName("c-form__network-error")[0].style.display =
            "none";

        let XHR = new XMLHttpRequest();
        let FD = new FormData(form);
        try {
            const userTracker = new UserTracker();
            const trackingData = userTracker.getCurrentSession();
            FD.append('tracking_data', JSON.stringify(trackingData));
        } catch (e) {
            _isDefined('Bugsnag') && Bugsnag.notify(e);
        }

        const fbTrackFormConversion = document.querySelector(".c-lander--fbconvtrack form") ? true : false;

        saveUserInfoToLocal(FD.get("full_name"), FD.get("email"), FD.get("effect"), FD.get("phone"), FD.get("requested_service"), fbTrackFormConversion);
        FD.append("ajax", 1); //tell formparser this is an ajax request

        XHR.addEventListener("load", function (e) {

            if (XHR.status === 200) {
                let tyParams = [];
                let tyPage = "/thank-you/";
                const formType = form.classList.contains('c-form--dfe') ? "Meso DFE" : form.querySelector('[name=requested_service');

                try {
                    if (_isDefined('mixpanel') && _isDefined('track', mixpanel)) {
                        mixpanel.track("Form Submit Success", { formType: formType });
                    }
                } catch (e) {
                    _isDefined('Bugsnag') && Bugsnag.notify(
                        new Error(
                            "Mixpanel Form Submit Success Event Unsuccessful"
                        ),
                        function (e) { }
                    );
                }

                if (typeof formSuccessEvent === "function") {
                    formSuccessEvent(form, { formType: formType });
                }

                if (
                    form.querySelector("input[name=ty_page]") &&
                    form.querySelector("input[name=ty_page]").value
                )
                    tyPage = form.querySelector("input[name=ty_page]").value;
                if (
                    form.querySelector("input[name=universal_leadid]") &&
                    form.querySelector("input[name=universal_leadid]").value
                ) {
                    sessionStorage.setItem("typara", 1);
                }

                if (form.dataset.filedownload) {
                    //hide the parent wrapper of the form and show the js thank you div
                    form.parentElement.style.display = "none";
                    document.querySelector(".js-thankyou").style.display = "block";
                    //if there is a download link in the thank you with correct id, download it
                    if (document.getElementById("formDownloadLink")) {
                        document.getElementById("formDownloadLink").click();
                    }
                } else if (tyParams.length > 0) {
                    form.action = "";
                    form.submit(); //submit form for jornaya
                    window.location.href = tyPage + "?" + tyParams.join("&");
                } else {
                    form.action = "";
                    form.submit(); //submit form for jornaya
                    window.location.href = tyPage;
                }
            } else {
                sumbitError(form, XHR.status);
            }
        });

        XHR.addEventListener("error", function (e) {
            sumbitError(form, "XMLHttpRequest event error");
        });

        XHR.open("POST", form.action);

        try {
            if (_isDefined('mixpanel') && _isDefined('track', mixpanel)) {
                if (FD.entries())
                    mixpanel.track(
                        "Form Submit Attempt",
                        Object.fromEntries(FD.entries())
                    ); //this should send all form fields to mixpanel
                if (FD.get("full_name"))
                    mixpanel.people.set({ $name: FD.get("full_name") });
                if (FD.get("email"))
                    mixpanel.people.set({ $email: FD.get("email") });
                if (FD.get("phone"))
                    mixpanel.people.set({ $phone: FD.get("phone") });
            }
        } catch (e) {
            _isDefined('Bugsnag') && Bugsnag.notify(
                new Error("Mixpanel Form Submit Attempt Event Unsuccessful"),
                function (e) { }
            );
        }

        XHR.send(FD);
    }

    function sumbitError(form, status) {
        const errorInput = form.getElementsByClassName("c-form__submit-error")[0]
        form.classList.remove("c-form--submitting");
        errorInput.disabled = false;

        try {
            if (_isDefined('mixpanel') && _isDefined('track', mixpanel)) {
                mixpanel.track("Form Submit Error", { count: errorNum + 1 });
            }
        } catch (e) {
            _isDefined('Bugsnag') && Bugsnag.notify(
                new Error("Mixpanel Form Submit Error Event Unsuccessful"),
                function (e) { }
            );
        }

        if (errorNum < errorMax) {
            errorInput.style.display = "block";
            errorInput.innerHTML = "Sorry there was an error. Please wait a moment and try again.";

            _isDefined('Bugsnag') && Bugsnag.notify(new Error("form ajax network parser error"), function (
                e
            ) {
                e.severity = "error";
                e.context = "form-ajax-error";
                e.addMetadata("submit-attempts", { count: errorNum + 1 }),
                    e.addMetadata("xmlstatus", { code: status });
            });
        } else {
            form.classList.add("c-form--disabled");
            errorInput.style.display = "block";
            errorInput.innerHTML = "Sorry there was an error. Please try again later.";
            errorInput.style.visibility = "visible";
            errorInput.style.position = "absolute";
            errorInput.style.zIndex = "1000";

            _isDefined('Bugsnag') && Bugsnag.notify(
                new Error("form ajax network parser error disabled"),
                function (e) {
                    e.severity = "error";
                    e.context = "form-ajax-error-disabled";
                    e.addMetadata("submit-attempts", { count: errorNum + 1 }),
                        e.addMetadata("xmlstatus", { code: status });
                }
            );
        }
        errorNum++;
    }

    const navigateToStep = (form, currentStep, targetStep, targetStepNum) => {
        if (currentStep.dataset.skipTransition === "true" || currentStep.dataset.step > targetStepNum) {
            transitionStep(currentStep, targetStep);
            return;
        }

        form.classList.add("c-form--submitting");
        form.getElementsByClassName("c-form__submit")[0].disabled = true;

        const activeNav = form.querySelector('.c-form__nav-button[data-stepchange="' + currentStep.dataset.step + '"]');
        const targetNav = form.querySelector('.c-form__nav-button[data-stepchange="' + targetStepNum + '"]');

        setTimeout(function () {
            transitionStep(currentStep, targetStep);

            activeNav?.classList.remove("is-active");
            targetNav?.classList.add("is-active");

            form.classList.remove("c-form--submitting");
            form.getElementsByClassName("c-form__submit")[0].disabled = false;
        }, 1000);
    }

    const transitionStep = (currentStep, targetStep) => {
        currentStep.style.display = "none";
        currentStep.classList.remove("is-active");

        targetStep.style.display = "block";
        targetStep.classList.add("is-active");

        const tmpformSubtext = document.querySelector(".c-form__subtext");
        if (tmpformSubtext) {
            const buttonFormNav = document.querySelector(".c-form__nav-button");
            if (buttonFormNav && buttonFormNav.classList.contains("is-active")) {
                buttonFormNav.style.marginTop = "1rem";
            }
        }
    }

    //element.closest polyfill. Remove when we move away from ie11
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            var el = this;

            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    var isDateSupported = function () {
        var input = document.createElement("input");
        var value = "a";
        input.setAttribute("type", "date");
        input.setAttribute("value", value);
        return input.value !== value;
    };

    //adding old browser fallback for date fields
    if (!isDateSupported()) {
        var dates = document.querySelectorAll("input[type=date]");
        for (i = 0; i < dates.length; i++) {
            dates[i].type = "text";
            dates[i].name = "date_of_birth_reformat";
            dates[i].addEventListener("input", dob_mask, false);
        }
    }

    const dob_mask = (e) => {
        e.target.value = date_mask(e.target.value);
    }

    const date_mask = (val) => {
        return val
            .replace(/[^\d/]/g, "") //replace non digits and '\'
            .replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2") //change 01/011 -> 01/01/1
            .replace(/^(\d{2})(\d)/, "$1/$2") //change 010 -> 01/0
            .replace(/(\/\d{4})\d+?$/, "$1"); //limit last set of numbers to 4 digits
    }

    const checkCountryOrigin = (form) => {
        const countryName = form.querySelector("select[name=country]");

        if (countryName?.value != "UK") {
            return;
        }

        if (!form.querySelector("input[name=requested_service_detail]")) {
            const requestedServiceDetail =
                '<input type="hidden" name="requested_service_detail" value="United Kingdom"></input>';
            const requestedService = form.querySelector(
                "input[name=requested_service]"
            );

            requestedService.insertAdjacentHTML("afterend", requestedServiceDetail);
        }

        const phoneNumber = form.querySelector("input[name=phone]");
        const preferredContact = form.querySelector("select[name=preferred_contact]");

        if (phoneNumber && preferredContact) {
            phoneNumber.parentNode.remove();
            preferredContact.parentNode.remove();
        }
    }

    const addErrorMessage = (groupElement, inputElement, errorMessage) => {
        if (groupElement && !groupElement.classList.contains("has-error")) {
            let errorSpan = document.createElement("span");
            errorSpan.className = "c-form__label c-form__label--error js-errorMessage";
            errorSpan.innerHTML = errorMessage;
            errorSpan.id = "error_" + inputElement.id;
            groupElement.classList.add("has-error");
            inputElement.parentElement.appendChild(errorSpan);
        }
    }

    const removeErrorMessage = (groupElement) => {
        groupElement?.classList.remove("has-error");
        groupElement?.querySelector(".js-errorMessage").remove();
    }

    const ajaxValidation = (form) => {
            form.classList.add("c-form--submitting");
            let phoneInput = form.querySelector("input[name=phone]");
            let phoneGroup = phoneInput?.closest(".js-formGroup");

            var emailValue =
                form.querySelector("input[name=email]") !== null
                    ? form.querySelector("input[name=email]").value
                    : "";
            var phoneValue =
                form.querySelector("input[name=phone]") !== null
                    ? form.querySelector("input[name=phone]").value
                    : "";

            var data = {
                email: emailValue,
                phone: phoneValue
            };

            try {
                fetch("/wp-content/themes/asbestos/ajax/validation.php", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Network response was not ok: ${response.statusText}`);
                        }
                        return response.json();
                    })
                    .then(responseData => {
                        if (phoneValue && responseData.phone === false) {
                            form.classList.remove("c-form--submitting");
                            addErrorMessage(phoneGroup, phoneInput, "Please provide a valid phone number.");
                            return;
                        }

                        if (responseData.phone !== false && phoneGroup?.classList.contains("has-error")) {
                            removeErrorMessage(phoneGroup);
                        }

                        form.classList.remove("c-form--submitting");

                        sendFormData(form);
                    })
                    .catch(error => {
                        form.classList.remove("c-form--submitting");
                        sumbitError(form, error);
                    });
            } catch (error) {
                console.error("Error during fetch:", error);
            }
    };
}
